export const enum ProjectStatus {
  Draft = 0,
  Active = 1,
  Archived = 2,
}
